/* eslint-disable react/prop-types */
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getEstadosDeSuspensionesDePagos } from 'api/nominas/suspensiones/estadosDeSuspensiones';
import { getHistoricosSuspensionesDePagos } from 'api/nominas/suspensiones/historicoSuspensionDePagos';
import { getMotivosDeSuspensionesDePagos } from 'api/nominas/suspensiones/motivosDeSuspensionesDePagos';
import { checkToken } from 'api/utils';
import Table from 'components/Table';
import React, { useEffect, useState } from 'react';
import { formatReceived } from 'utils/formatValues';
import { getModelPermission } from 'utils/permission';
import { getTiposDeSuspensionesDePagos } from 'api/nominas/suspensiones/tiposDeSuspensionesDePagos';
import percentFormatter from 'utils/percentFormatter';

export const HistoricoSuspensionDePagosPermission = {
  permissionModel: 'historicosuspensiondepagoempleado',
  catalogsModels: [],
  tabsModels: [],
};

const ExpedienteSuspensiones = ({
  currentEmpleado,
}) => {
  const [motivosSuspensionDePago, setMotivosSuspensionDePago] = useState([]);
  const [tiposSuspensiones, setTiposSuspensiones] = useState([]);
  const [periodosNominaDetalle, setPeriodosNominaDetalle] = useState([]);
  const [estatusSuspensiones, setEstatusSuspensiones] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getPermission = getModelPermission(
    HistoricoSuspensionDePagosPermission.permissionModel,
    HistoricoSuspensionDePagosPermission.catalogsModels,
    HistoricoSuspensionDePagosPermission.tabsModels,
    false,
  );

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _motivosSuspensiones,
        _tiposSuspensiones,
        _periodosNominasDetalles,
        _estatusSuspensiones,
        _data,
      ] = await Promise.all([
        getMotivosDeSuspensionesDePagos(),
        getTiposDeSuspensionesDePagos(),
        getPeriodosDeNominasDetalles(),
        getEstadosDeSuspensionesDePagos(),
        getHistoricosSuspensionesDePagos({ empleado: currentEmpleado }),
      ]);
      if (mounted) {
        setMotivosSuspensionDePago(_motivosSuspensiones);
        setTiposSuspensiones(_tiposSuspensiones);
        setPeriodosNominaDetalle(formatReceived(_periodosNominasDetalles));
        setEstatusSuspensiones(_estatusSuspensiones);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    if (currentEmpleado) {
      fetchAll();
    } else {
      setData([]);
      setLoading(false);
    }
    return () => { mounted = false; };
  }, [currentEmpleado]);

  const columns = [
    {
      titleText: 'Motivo de Suspensión de Pago',
      dataIndex: 'motivo_de_suspension_de_pago',
      key: 'motivo_de_suspension_de_pago',
      width: 300,
      render: (val) => motivosSuspensionDePago.find((e) => e.id === val)?.motivo,
    },
    {
      titleText: 'Tipo de Suspensión',
      dataIndex: 'tipo_de_suspension_de_pago',
      key: 'tipo_de_suspension_de_pago',
      width: 200,
      render: (val) => tiposSuspensiones.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: '% de Pago',
      dataIndex: 'porcentaje_de_pago',
      key: 'porcentaje_de_pago',
      width: 200,
      render: (val) => percentFormatter(val),
    },
    {
      titleText: 'Periodo de Nómina Inicial',
      dataIndex: 'periodo_de_nomina_detalle_inicial',
      key: 'periodo_de_nmomina_detalle_inicial',
      width: 300,
      render: (val) => {
        const _periodo = periodosNominaDetalle.find((e) => e.id === val);
        const _fechaInicial = _periodo?.fecha_inicial.format();
        const _fechaFinal = _periodo?.fecha_final.format();
        return `${_periodo?.numero_de_nomina} - ${_fechaInicial} al ${_fechaFinal}`;
      },
    },
    {
      titleText: 'Periodo de Nómina Final',
      dataIndex: 'periodo_de_nomina_detalle_final',
      key: 'periodo_de_nomina_detalle_final',
      width: 300,
      render: (val) => {
        const _periodo = periodosNominaDetalle.find((e) => e.id === val);
        const _fechaInicial = _periodo?.fecha_inicial.format();
        const _fechaFinal = _periodo?.fecha_final.format();
        return `${_periodo?.numero_de_nomina} - ${_fechaInicial} al ${_fechaFinal}`;
      },
    },
    {
      titleText: 'Fecha de Liberación o Baja',
      dataIndex: 'fecha_liberacion_cancelacion',
      key: 'fecha_liberacion_cancelacion',
      width: 300,
      render: (val) => val?.format('DD/MM/YYYY'),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estado_suspension',
      key: 'estado_suspension',
      width: 200,
      render: (val) => estatusSuspensiones.find((e) => e.id === val)?.descripcion,
    },
  ];
  return (
    <Table
      cols={columns}
      data={data}
      permission={getPermission}
      allowExportPDF={false}
      loading={loading}
    />
  );
};

export default ExpedienteSuspensiones;
